<template>
  <!-- 联系我们 -->
  <div>
    <section
      id="contact"
      v-lazy:background-image="require('../assets/images/footer/footer.png')"
      class="section contact bg-lightan"
    >
      <div class="custom-container">
        <div class="contact-logo">
          <img
            v-lazy="require('../assets/images/footer/logo.png')"
            class="img-horizontal"
            alt="primihub"
          > 
          <img
            v-lazy="require('../assets/images/footer/logo-blue-white.png')"
            class="img-vertical"
            alt="primihub"
          >
        </div>
        <div class="contact-us">
          <h5>联系我们</h5>
          <ul class="list-unstyled text-left">
            <li>
              <img v-lazy="require('../assets/images/footer/phone.png')">联系电话<span>400-7788-685 / 18515152260（李先生）</span>
            </li>
            <li><img v-lazy="require('../assets/images/footer/counselling.png')">公司地址<span>北京市海淀区西小口路66号中关村东升科技园B-2楼一层D101A-51室</span></li>
            <li><img v-lazy="require('../assets/images/footer/phone.png')">简历投递 <span>hr@primihub.com </span></li>
            <li><img v-lazy="require('../assets/images/footer/local.png')">合作咨询<span>business@primihub.com</span></li>
          </ul>
        </div>
        <div class="qrcode  justify-content-center">
          <div class="row align-items-center justify-content-center">
            <h5>关于我们</h5>
            <div class="col-5 text-center">
              <img
                v-lazy="require('../assets/images/qrcode.jpg')"
                alt="关于我们"
                width="90"
              >
              <p class="qrcode-text">
                原语科技公众号
              </p>
            </div>
            <div class="col-5 text-center">
              <img
                v-lazy="require('../assets/images/qrcode1.png')"
                alt="原语科技小助手"
                width="90"
              >
              <p class="qrcode-text">
                原语科技小助手
              </p>
            </div>
          </div>
        </div>
        <div class="text-center footer">
          <p>
            北京原语科技有限公司 版权所有 <span><a href="https://beian.miit.gov.cn/#/Integrated/index">京ICP备2022006522号-1</a></span>
            ｜
            <span><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802039051"><img
              v-lazy="require('../assets/images/balogo.d0289dc0.png')"
              alt="备案"
            >京公网安备 11010802039051号</a></span>
          </p>
        </div>
      </div>
    </section>
    <div class="text-center footer">
      <p>
        北京原语科技有限公司 版权所有 <span><a href="https://beian.miit.gov.cn/#/Integrated/index">京ICP备2022006522号-1</a></span>
        ｜
        <span><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802039051"><img
          v-lazy="require('../assets/images/balogo.d0289dc0.png')"
          alt="备案"
        >京公网安备 11010802039051号</a></span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactPage"
}
</script>

<style scoped lang="scss">
.custom-container{
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  .footer{
    display: none;
  }
}
.contact{
  // background-size: 100%;
  background-position: center top;
  background-repeat: no-repeat;
  height: 386px;
  text-align: left;
  color: #ffffff;
  .contact-us{
    .list-unstyled{
      font-size: 12px;
      line-height: 40px;
      margin-top: 40px;
      li{
        img{
          margin-right: 8px;
        }
        span{
          margin-left: 8px;
        }
      }
    }
  }
}
.footer{
  font-size: 12px;
  overflow: hidden;
  background: #262D3F;
}
.footer p{
  line-height: 1;
  margin-bottom: 5px;
  color: rgba(255, 255, 255, .5);
}
.footer a{
  color: rgba(255, 255, 255, .5);
}
.contact-box {
  margin-bottom: -60px;
  margin-top: 90px;
  position: relative;
  background: #ffffff;
  padding: 30px 40px 40px 40px;
  border-radius: 10px;
  box-shadow: 0px 2px 10px 0px rgba(22, 85, 197, 0.06);
}
.bg-footer {
  padding-top: 120px;
  margin-bottom: 80px;
}

.footer-link a {
  color: #9197b5;
  line-height: 38px;
  font-size: 15px;
  -webkit-transition: all 0.5s;
  background-color: transparent;
  transition: all 0.5s;
}

.footer-link a:hover {
  color: #215ae7;
}

.footer-email input {
  padding: 12px 8px;
  width: 100%;
  font-size: 15px;
  color: #9197b5;
  border: none;
  border-bottom: 2px solid rgba(33, 90, 231, 0.4);
  outline: none !important;
  background-color: transparent;
  padding-right: 80px;
}

.footer-email input::placeholder {
  color: #9197b5;
}

.footer-email button {
  position: absolute;
  top: 6px;
  right: 8px;
  outline: none !important;
  border-radius: 30px;
  font-size: 14px;
  padding: 5px 15px;
}

.footer-email form {
  position: relative;
  max-width: 600px;
}
.qrcode{
  h5{
    text-indent: 39px;
    margin-bottom: 45px;

    &:after{
      margin-left: 39px;
    }
  }
  img{
    display: block;
    margin: auto;
  }
  .qrcode-text{
    margin-top: 5px;
    display: inline-block;
    
  }
}
.contact-logo{
  width: 192px;
  height: 249px;
  background: #54565D;
  display: flex;
  justify-content: center;
  align-items: center;
  .img-vertical{
    display: none;
  }
  .img-horizontal{
    width: 96px;
    object-fit: cover;
  }
}

h5{
  font-size: 16px;
  &::after{
    content:'';
    display: block;
    width: 60px;
    height: 3px;
    margin-top: 10px;
    background: #fff;
  }
}
.container{
  max-width:1200px;
  margin-top: 63px;
  // .contact-us{
  //   .list-unstyled{
  //     // font-size: 12px;
  //     // line-height: 40px;
  //     // margin-top: 40px;
  //     li{
  //       color: #D8D8D8;
  //       img{
  //         margin-right: 10px;
  //         display: inline-block;
  //         width: 20px;
  //         height: 20px;
  //       }
  //       span{
  //         margin-left:10px;
  //         color: #999;
  //       }
  //     }
  //   }
  // }
}
@media (max-width: 1000px)  {
  .contact{
    height: auto;
    .contact{
      background-size: 300% 100%;
    }
    .custom-container{
      padding: 0 40px;
      display: block;
      height: auto;
      .footer{
        display: block;
        background: transparent;
        padding: 36px 40px 36px;
      }
    }
    .qrcode{
      width: 100%;
      position: relative;
      h5{
        text-indent: 0px;
        &:after{
          margin-left: 0px;
        }
      }
    }
  }
  
  .contact-logo{
    // display: none;
    width: 100%;
    height: 70px;
    .img-vertical{
      display: block;
      width: 130px;
    }
    .img-horizontal{
      display: none;
    }
  }
  h5{
    text-align: center;
    margin-top: 40px;
    &:after{
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .contact-us{
    width: 100% !important;
    position: relative;
   
    .list-unstyled{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      li{
        width: 45%;
        text-align: center;
        &:nth-of-type(n+3){
            margin-top: 20px;
        }
        img{
          display:block !important;
          margin: 0 auto !important;
        }
        span{
          line-height: 1.6;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .footer{
    display: none;
  }

}
@media (max-width: 750px) {
  .contact{
    background-size: 400% 100%;
  }
}
</style>
